import {
  Sequence,
  SequenceAgent,
  SequenceDashboard,
  SequenceHistoryChange,
  SequenceStatus,
} from "@/@types/flows/sequences";
import { CreateSequenceDto, ListFilterDto } from "@/@types/flows/sequences/dto";
import httpManager from "@/app/shared/utils/httpManager";

class SequenceService {
  private baseUrl = "/sequences";

  async getList(filters: ListFilterDto | undefined): Promise<Sequence[]> {
    let name = filters?.name ? filters.name : "";
    let status = filters?.status ? filters.status : "";
    let portfolio = filters?.portfolio ? filters.portfolio : "";
    let channel = filters?.channel ? filters.channel : "";
    let type = filters?.type ? filters.type : "";
    const url = `${this.baseUrl}/?name=${name}&status=${status}&portfolio=${portfolio}&channel=${channel}&type=${type}`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async getById(id: number): Promise<Sequence> {
    const url = `${this.baseUrl}/${id}/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async create(createSequenceDto: CreateSequenceDto): Promise<Sequence> {
    const url = `${this.baseUrl}/`;

    const response = await httpManager.post(url, {
      ...createSequenceDto,
      channels_customers: createSequenceDto.channels_customers || [],
    });

    return response.data;
  }

  async update(id: number, updateSequenceDto: Partial<CreateSequenceDto>) {
    const url = `${this.baseUrl}/${id}/`;

    await httpManager.put(url, updateSequenceDto);
  }

  async toggleState(sequence: Sequence) {
    const url = `${this.baseUrl}/${sequence.id}/`;
    const body = {
      status:
        sequence.status === SequenceStatus.Active ? SequenceStatus.Inactive : SequenceStatus.Active,
    };

    await httpManager.put(url, body);
  }

  async delete(id: number) {
    const url = `${this.baseUrl}/${id}/`;

    await httpManager.delete(url);
  }

  async getChangeHistory(id: number): Promise<SequenceHistoryChange[]> {
    const url = `${this.baseUrl}/${id}/history/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async getDashboard(id: number): Promise<SequenceDashboard> {
    const url = `${this.baseUrl}/${id}/dashboard/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async downloadReport(id: number, dates: any = null) {
    let url = `${this.baseUrl}/${id}/download/`;

    console.log(dates, 'dates download');
    if (dates?.startDate)
      url += `?start_date=${dates?.startDate?.substring(0, 10)} 00:00:00`
    if (dates?.endDate)
      url += `&end_date=${dates?.endDate?.substring(0, 10)} 23:59:59`
    const response = await httpManager.getBlob(url);

    return response;
  }

  async checkSequenceStatus(): Promise<boolean> {
    const url = `${this.baseUrl}/check/active/`;

    const response = await httpManager.get(url);

    return response.data?.is_active ?? false;
  }

  async getAgentsById(id: number, page: number = 1): Promise<SequenceAgent[]> {
    const TABLE_PAGE_SIZE = 20;
    const limit = TABLE_PAGE_SIZE;
    const offset = (page - 1) * TABLE_PAGE_SIZE;
    const url = `/sequences/${id}/contacts/?limit=${limit}&offset=${offset}`;

    const response = await httpManager.get(url);

    // return response.data;
    return response.data;
  }

  async deleteAgent(agents: any[] | any) {
    const url = `/sequences/contacts/delete/`;

    if (Array.isArray(agents)) await httpManager.post(url, { contacts: agents });
    else await httpManager.delete(url, { contacts: agents });
  }

  async getDataSequence(id: number): Promise<SequenceDashboard> {
    const url = `${this.baseUrl}/${id}/data/`;

    const response = await httpManager.get(url);

    return response.data;
  }
}

export const sequenceService = new SequenceService();
